var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrangeSquare2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1801 6.09998C9.77008 6.09998 9.43008 6.43998 9.43008 6.84998V15.35L7.67008 13.59C7.38008 13.3 6.90008 13.3 6.61008 13.59C6.32008 13.88 6.32008 14.36 6.61008 14.65L9.65008 17.69C9.72008 17.76 9.80008 17.81 9.89008 17.85C9.98008 17.89 10.0801 17.91 10.1801 17.91C10.2801 17.91 10.3701 17.89 10.4701 17.85C10.6501 17.77 10.8001 17.63 10.8801 17.44C10.9201 17.35 10.9401 17.25 10.9401 17.15V6.84998C10.9301 6.42998 10.6001 6.09998 10.1801 6.09998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3901 9.35998L14.3501 6.31998C14.2801 6.24998 14.2001 6.19998 14.1101 6.15998C13.9301 6.07998 13.7201 6.07998 13.5401 6.15998C13.3601 6.23998 13.2101 6.37998 13.1301 6.56998C13.0901 6.65998 13.0701 6.75998 13.0701 6.85998V17.17C13.0701 17.58 13.4101 17.92 13.8201 17.92C14.2301 17.92 14.5701 17.58 14.5701 17.17V8.66998L16.3301 10.43C16.4801 10.58 16.6701 10.65 16.8601 10.65C17.0501 10.65 17.2401 10.58 17.3901 10.43C17.6801 10.12 17.6801 9.64998 17.3901 9.35998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrangeSquare2);
export default __webpack_public_path__ + "static/media/arrange-square-2.c72e5be04af9346c9c9671b114937c81.svg";
export { ForwardRef as ReactComponent };